import React from 'react';
import { Link } from 'dva/router';
import moment from 'moment';
import LinesEllipsis from 'react-lines-ellipsis';
import HTMLEllipsis from 'react-lines-ellipsis/lib/html';
import styles from './index.css';

export default ({novel_id, name, update_time, title, author_name, tag_name, idx, is_vip}) => (
<div>
    <div style={{display:'flex',flexWrap:'wrap',justifyContent:'space-between',background:idx%2===0?null:'#f9f9f9',lineHeight:'54px'}}>
    	<div style={{width:'110px'}}><Link to={`/category`} style={{fontSize:'14px',color:'#999',textAlign:'left'}}>[{tag_name}]</Link></div>
		<Link to={`/book/detail/${novel_id}`} style={{margin:'0 20px',flex:1,fontSize:'16px',color:'#333',textAlign:'left'}} className={is_vip&&Number(is_vip)===1?styles.htmlellipsis_wrap_vip:styles.htmlellipsis_wrap}>
			<div >
				{is_vip&&Number(is_vip)===1?
					<HTMLEllipsis unsafeHTML={`<div>${name} <em>${title}</em></div>`} maxLine={1} />
				:
					<HTMLEllipsis unsafeHTML={`<div>${name} <em>${title}</em></div>`} maxLine={1} />
				}
				
			</div>
		</Link>
		{/*<div style={{margin:'0 20px',flex:1,fontSize:'16px',color:'#666',textAlign:'left'}}><LinesEllipsis text={novel_name+' '+name} maxLine={1}/></div>*/}
        <div style={{width:'180px',paddingLeft:'19px',boxSizing:'border-box'}}>
        	<Link to={`/book/detail/${novel_id}`} style={{fontSize:'14px',color:'#333',boxSizing:'border-box'}}>
        		<LinesEllipsis text={author_name} maxLine={1}/>
        	</Link>
        </div>
        <div style={{width:'110px'}}>
        	<Link to={`/book/detail/${novel_id}`} style={{fontSize:'14px',color:'#999'}}>
        		{moment(update_time * 1000).format('MM-DD HH:mm')}
        	</Link>
        </div>            
    </div>
</div>
)



// WEBPACK FOOTER //
// ./src/component/book/styl_brief_13.js